import { InjectionToken } from '@angular/core';

/**
 * Configuration interface for the RadarService
 * Each application provides its own config via this token
 */
export interface RadarServiceConfig {
  /** Radar publishable key for SDK initialization */
  publishableKey: string;
  
  /** Country code(s) for Radar autocomplete (e.g., 'US' or 'US,CA') */
  countryCode?: string;
  
  /** Radar map style ID */
  mapStyle?: string;
  
  /** S3 config URL for additional configuration */
  s3ConfigUrl?: string;
}

/**
 * Injection token for RadarService configuration
 * 
 * @example
 * ```typescript
 * providers: [
 *   {
 *     provide: RADAR_SERVICE_CONFIG,
 *     useValue: {
 *       publishableKey: environment.radarPublishableKey,
 *       countryCode: environment.radarCountryCode,
 *       mapStyle: environment.radarMapStyle,
 *       s3ConfigUrl: environment.s3ConfigUrl
 *     }
 *   }
 * ]
 * ```
 */
export const RADAR_SERVICE_CONFIG = new InjectionToken<RadarServiceConfig>('RADAR_SERVICE_CONFIG');
